import { inputFormReducerFactory } from 'state/secondaryMarket/shared/form/input/input.reducer';

import type { LiveForm, LiveInputForm } from './inputForm.model';
import { initialLiveForm, initialLiveFormMap } from './inputForm.model';

export const liveInputFormReducer = inputFormReducerFactory<LiveForm, LiveInputForm, 'LIVE'>(
  'LIVE',
  initialLiveFormMap,
  initialLiveForm,
  'live',
);
